import logo from "./logo.svg";
import "./App.css";
import React from "react";
import { Page } from "./components/page";
import { Button } from "react-bootstrap";
import { inject, observer } from "mobx-react";
import LoginForm from "./components/login";

@inject("formStore")
@observer
class App extends React.Component {
    render() {
        if (!this.props.formStore.isLoggedIn) {
            return <LoginForm />;
        }
        return <Page></Page>;
    }
}

export default App;
